import { makeAutoObservable } from 'mobx';
import { IAttendee } from '../../../api/dao/attendee-dao';
import { AttendeeStatus } from '../../../constans/attendee-enums';
import { UNKNOWN_EMAIL } from '../../../constans/common-constants';

interface IAttendeeInfo {
    name: string;
    email: string;
    arrival: string;
    departure: string;
}

interface IAttendeeEntity extends IAttendee {
    getAttendeeInfo(): IAttendeeInfo;

    getViewerId(): string;

    getAttendeeStatus(): AttendeeStatus;

    getArrivalTime(): string;
}

class AttendeeEntity implements IAttendeeEntity {
  public arrival: string;
  public attendeeStatus: AttendeeStatus;
  public email: string;
  public name: string;
  public presentationId: string;
  public viewerId: string;
  public departure: string;
  public inProcessing = false;

  constructor (
    fromDTO: IAttendee
  ) {
    makeAutoObservable(this);
    this.deserialize(fromDTO);
  }

  public getViewerId = (): string => {
    return this.viewerId;
  };

  public getAttendeeInfo = (): IAttendeeInfo => ({
    name: this.name,
    email: this.email,
    arrival: this.arrival,
    departure: this.departure,
  });

  public getAttendeeStatus = (): AttendeeStatus => {
    return this.attendeeStatus;
  };

  public getArrivalTime = (): string => {
    return this.arrival;
  };

  public isEntityLocked = (): boolean => {
    return this.inProcessing;
  };

  private deserialize = (fromDTO: IAttendee): void => {
    this.arrival = fromDTO.arrival;
    this.attendeeStatus = fromDTO.attendeeStatus;
    this.email = fromDTO.email === UNKNOWN_EMAIL ? '' : fromDTO.email;
    this.name = fromDTO.name;
    this.viewerId = fromDTO.viewerId;
    this.departure = fromDTO.departure;
  };
}

export { AttendeeEntity };